import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppRooute } from 'src/app/core/common/app-route.model';
import { AppSettings } from 'src/app/core/common/app-settings';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { StateConstant } from 'src/app/core/common/state-constant';
import { DesaparecidoService } from 'src/app/core/services/caso/desaparecido.service';
import { DesaparecidoVo } from 'src/app/shared/models/caso/desaparecido-vo.model';
import { environment } from 'src/environments/environment';

import jsPDF from 'jspdf';
import autoTable, { RowInput } from 'jspdf-autotable';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ExportType, MatTableExporterDirective } from 'mat-table-exporter';
import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

@Component({
  selector: 'vex-desaparecido-list',
  templateUrl: './desaparecido-list.component.html',
  styleUrls: ['./desaparecido-list.component.scss']
})
export class DesaparecidoListComponent implements OnInit {

  appSettings = AppSettings;
  stateConstant = StateConstant;

  dataSource: MatTableDataSource<DesaparecidoVo>;
  displayedColumns: string[] = ['urlThumbnail', 'id', 'apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'sexo', 'nacionalidad', 'departamento', 'provincia', 'municipio', 'encontrado', 'fechaDesaparicion', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("exporter") exporter!: MatTableExporterDirective;

  selection = new SelectionModel<DesaparecidoVo>(true, []);
  searchKey: string;

  desaparecidoService = inject(DesaparecidoService);

  desaparecidos: DesaparecidoVo[];

  crumbs: AppRooute[] = [RouteConstant.ROUTE_CASE_MISSING];
  reportData: RowInput = [];

  formSearch: FormGroup;

  constructor(private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private toatrService: ToastrService) {
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.desaparecidoService.findAll().subscribe(
      response => {
        this.desaparecidos = response.data
        this.dataSource = new MatTableDataSource(response.data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      err => {
        console.error(err);
      }
    )
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  detail(vo: DesaparecidoVo) {
    this.router.navigate([`./${RouteConstant.ROUTE_CASE_MISSING.url}/${vo.id}`]);
  }

  downloadPdf() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'a4'
    });
    doc.addFont('assets/fonts/PTSans.ttf', 'PTSans', 'normal');
    let bodyData: any[] = [];
    this.desaparecidos.forEach(function (desaparecido) {
      bodyData.push([desaparecido.apellido_paterno, desaparecido.apellido_materno, desaparecido.nombres, desaparecido.documento, desaparecido.sexo, desaparecido.nacionalidad, desaparecido.departamento, desaparecido.provincia, desaparecido.municipio, desaparecido.encontrado ? 'Si' : 'NO', desaparecido.fechaDesaparicion]);
    });
    autoTable(doc, {
      head: [['Paterno', 'Materno', 'Nombres', 'Documento', 'Sexo', 'Nacionalidad', 'Departamento', 'Provincia', 'Municipio', 'Encontrado', 'Fecha desaparecido']],
      body: bodyData,
      styles: {
        fontSize: 6
      }
    })
    doc.save('desaparecidos.pdf')
  }


  download() {
    console.log("Downloading");
    this.exporter.exportTable(ExportType.XLSX, {
      fileName: "all-results",
      Props: {
        Author: "john"
      }
    })
  };

  exportarExcel() {
    // 1️⃣ Definir las columnas a exportar y sus encabezados personalizados
    const columnas = ['id', 'apellido_paterno', 'apellido_materno', 'nombres', 'documento', 'sexo', 'nacionalidad', 'departamento', 'provincia', 'municipio', 'encontrado', 'fechaDesaparicion']; // Solo estas columnas serán exportadas
    const encabezados = ['Identificador', 'Paterno', 'Materno', 'Nombres', 'Documento', 'Sexo', 'Nacionalidad', 'Departamento', 'Provincia', 'Municipio', 'Encontrado', 'Fecha desaparición'];

    // 2️⃣ Transformar los datos para incluir solo las columnas seleccionadas
    const datosTransformados = this.desaparecidos.map(fila =>
      columnas.map(col => fila[col]) // Extraer solo las columnas necesarias
    );

    // Convertir dataSource en hoja de cálculo
    //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.desaparecidos);

    // 3️⃣ Crear una hoja de cálculo con los encabezados personalizados
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([encabezados, ...datosTransformados]);

    // 4️⃣ Crear un libro de trabajo y agregar la hoja
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Datos');

    // 5️⃣ Guardar el archivo Excel
    //const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    // Generar y descargar el archivo Excel
    //const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    //saveAs(blob, 'datos.xlsx');
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'desaparecidos.xlsx';
    a.click();

    // Liberar memoria
    URL.revokeObjectURL(url);
  }

  syncJuliana() {
    this.desaparecidoService.syncJuliana().subscribe(
      response => {
        if (response.status) {
          this.toatrService.success(response.message);
          this.loadList();
        }
      },
      err => {
        console.error(err);
      }
    )
  }

  thumbnail(id: any): string {
    return environment.apiSecurityUrl + 'api/v1/util/stream/thumbnail/' + id;
  }
}
